import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import IForm from '../../../types/IForm';
import ConfigurationUpload from '../../../_lib/components/ConfigurationFileUpload/ConfigurationUpload';
import { Namespace } from '../../../translation/namespace';

type ConfigurationAggregateEditProps = { form: IForm };

function ConfigurationAggregateEdit({ form }: ConfigurationAggregateEditProps) {
  return <ConfigurationUpload namespace={Namespace.ConfigurationAggregate} name="file" form={form} />;
}

export const ConfigurationAggregateEditView = asView(ConfigurationAggregateEdit);
export type ConfigurationAggregateEditView = ComponentProps<typeof ConfigurationAggregateEditView>;
